import { InjectionToken } from "@angular/core";

export interface UserModuleConfig {
	production: boolean;
	url: string;
	demo: boolean;
	/** URL of the NestJS portal-backend */
	portalBackendUrl?: string;
}
export const USER_CONFIG = new InjectionToken<UserModuleConfig>("USER_CONFIG");
